import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MzBaseModal, MzModalComponent } from "ng2-materialize";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-error-dialog",
  templateUrl: "./license-expired-dialog.component.html",
  styleUrls: ["./license-expired-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LicenseExpiredDialogComponent
  extends MzBaseModal
  implements OnInit {
  env: any = environment;

  constructor() {
    super();
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/license-expired-dialog/license-expired-dialog.component.ts